// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Gg3r","left":"StickyBox_left__3tYl3","right":"StickyBox_right__3ml6u"};